import React from "react";

const NotFound = () => {
  return (
    <section className="ptb-100 notfoundsection">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <img
              width={631}
              height={437}
              className="notfoundimg"
              src="/assets/images/404img.png"
              alt="404 page"
              loading="lazy"
            />
            <h1 className="main-title mb-2 mt-lg-5 mt-4">
              Page Not Found
              {/* Data Not Found */}
            </h1>
            <p>
              We can't seem to find the page you're looking for.
              {/* We couldn't find the data you're looking for. It might have been moved or deleted. */}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
